export const USE_CURRENT_JOB = 'USE_CURRENT_JOB'

export interface UseCurrentJobAction {
	type: typeof USE_CURRENT_JOB
	payload: {
		useCurrentJob: boolean
	}
}

export type ActionType = UseCurrentJobAction

export class Actions {
	static useCurrentJob(use: boolean): UseCurrentJobAction {
		return {
			type: USE_CURRENT_JOB,
			payload: {
				useCurrentJob: use
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/serviceInfo.ts